import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiUrl, brands } from "../../config/config";

const RelatedProduct = ({ categoryId, categoryName }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const formattedName = categoryName
    ? categoryName.replace(/-/g, " ")
    : "Related Product";

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);

      try {
        const url = `${apiUrl}/api/${brands}/products/category/${categoryId}`;
        const res = await fetch(url);
        const data = await res.json();

        let productsList = [];

        if (Array.isArray(data)) {
          productsList = data.slice(0, 6);
        } else if (data.data && Array.isArray(data.data)) {
          productsList = data.data.slice(0, 6);
        }

        setProducts(productsList);
      } catch (err) {
        console.error("Product fetch error:", err);
        setProducts([]);
      }

      setLoading(false);
    };

    fetchProducts();
  }, [categoryId]);

  if (loading) {
    return (
      <p className="py-14 text-center text-[15px] font-medium text-[#415164] sm:py-16">
        Loading products...
      </p>
    );
  }

  if (products.length === 0) {
    return (
      <p className="py-14 text-center text-[15px] font-medium text-[#415164] sm:py-16">
        No products found in this category.
      </p>
    );
  }

  return (
    <div className="w-full bg-white py-10 sm:py-12 lg:py-14">
      <div className="mx-auto w-full max-w-[1200px] px-4 sm:px-6 lg:px-10">
        <div className="mb-8 text-center sm:mb-10">
          <h2 className="text-center text-3xl font-bold tracking-wide text-[#2b2b2b] md:text-4xl">
            Related Product
          </h2>

          <div className="mx-auto mt-6 h-px w-full max-w-[620px] bg-[#9ca3af]"></div>
        </div>

        <div className="grid grid-cols-2 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-7">
          {products.map((item) => (
            <Link
              key={item.id}
              to={`/product/${
                item.category?.category_name?.replace(/\s+/g, "-") ||
                "category"
              }/${item.category_id}/${item.name?.replace(/\s+/g, "-")}/${
                item.id
              }`}
              className="group mx-auto block h-full w-full max-w-[310px] overflow-hidden rounded-[16px] border border-[#d9d9d9] bg-[#f3f3f3] px-3 pb-5 pt-4 text-center shadow-[0_4px_18px_rgba(0,0,0,0.18)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_28px_rgba(0,0,0,0.24)] sm:px-5 sm:pb-6 sm:pt-5"
            >
              <div className="mx-auto flex h-[145px] w-full items-center justify-center overflow-hidden rounded-[12px] bg-transparent sm:h-[210px] lg:h-[230px]">
                <img
                  src={`${apiUrl}/storage/${item.image}`}
                  alt={item.name}
                  className="max-h-full max-w-full object-contain transition-transform duration-500 ease-out group-hover:scale-105"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/placeholder-image.jpg";
                  }}
                />
              </div>

              <h3 className="mt-5 text-center text-[15px] font-extrabold leading-[20px] text-black sm:text-[18px] sm:leading-[24px] lg:text-[20px]">
                {item.name}
              </h3>

              <p className="mx-auto mt-3 max-w-[230px] text-center text-[13px] font-medium leading-[22px] text-[#111827] sm:text-[15px] sm:leading-[26px]">
                As low as ${item.discountedPrice}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RelatedProduct;